import type { CMSConfig } from '#types/config/components/cms'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    carouselExternalControls: 'flex <md:hidden',
    carouselControls: 'h-10 w-10 bg-brand-1/50 p-2 c-white shadow-sm @hactive:bg-brand-1/90',
  },
  carouselArrows: 'mdNoTitle',
} satisfies RecursivePartial<CMSConfig['articleCarousel']>
